import type { Unit } from '@/shared/types'

const SU_DOAN_NAMES = [
  { code: 'SD-371', name: 'Sư đoàn Không quân X1' },
  { code: 'SD-372', name: 'Sư đoàn Không quân X2' },
  { code: 'SD-370', name: 'Sư đoàn Không quân X3' },
  { code: 'SD-361', name: 'Sư đoàn Phòng không Y1' },
  { code: 'SD-363', name: 'Sư đoàn Phòng không Y2' },
  { code: 'SD-365', name: 'Sư đoàn Phòng không Y3' },
]

const TRUNG_DOAN_PREFIXES = [
  'Trung đoàn KQ',
  'Trung đoàn Tiêm kích',
  'Trung đoàn Trực thăng',
  'Trung đoàn Vận tải',
  'Trung đoàn Tên lửa PK',
  'Trung đoàn Radar',
  'Trung đoàn Pháo PK',
]

function generateUnits(): Unit[] {
  const units: Unit[] = []

  units.push({
    id: 'qc-pkkq',
    code: 'QC-PKKQ',
    name: 'Quân chủng Phòng không – Không quân',
    level: 'quan-chung',
    parentId: null,
  })

  SU_DOAN_NAMES.forEach((sd, sdIdx) => {
    const sdId = `sd-${sdIdx + 1}`
    units.push({
      id: sdId,
      code: sd.code,
      name: sd.name,
      level: 'su-doan',
      parentId: 'qc-pkkq',
    })

    const trungDoanCount = 3
    for (let td = 1; td <= trungDoanCount; td++) {
      const tdId = `${sdId}-td${td}`
      const tdCode = `${sd.code}-T${td}`
      const prefix = TRUNG_DOAN_PREFIXES[(sdIdx * 3 + td - 1) % TRUNG_DOAN_PREFIXES.length]
      const tdName = `${prefix} ${900 + sdIdx * 10 + td}`
      units.push({
        id: tdId,
        code: tdCode,
        name: tdName,
        level: 'trung-doan',
        parentId: sdId,
      })

      for (let tieuD = 1; tieuD <= 3; tieuD++) {
        const tieuDId = `${tdId}-d${tieuD}`
        const tieuDCode = `${tdCode}.D${tieuD}`
        units.push({
          id: tieuDId,
          code: tieuDCode,
          name: `Tiểu đoàn ${tieuD} / ${tdName}`,
          level: 'tieu-doan',
          parentId: tdId,
        })

        for (let dd = 1; dd <= 3; dd++) {
          const ddId = `${tieuDId}-c${dd}`
          const ddCode = `${tieuDCode}.C${dd}`
          units.push({
            id: ddId,
            code: ddCode,
            name: `Đại đội ${dd} / Tiểu đoàn ${tieuD} / ${tdName}`,
            level: 'dai-doi',
            parentId: tieuDId,
          })
        }
      }
    }
  })

  return units
}

export const UNITS: Unit[] = generateUnits()

export const UNITS_BY_ID: Record<string, Unit> = Object.fromEntries(
  UNITS.map((u) => [u.id, u]),
)

export function getUnitsByLevel(level: Unit['level']): Unit[] {
  return UNITS.filter((u) => u.level === level)
}

export function getChildren(parentId: string): Unit[] {
  return UNITS.filter((u) => u.parentId === parentId)
}
